'use strict';

var dashboardUtil = require('../../util/dashboard-util');
var nocUtil = require('../../util/noc-util');

module.exports = /*@ngInject*/ ["$q", "DashboardService", "TripService", "TimeZoneFactory", function ($q, DashboardService, TripService, TimeZoneFactory) {
    var factory = {};

    factory.getProjectConsumptionData = function (projectId, callback) {
        DashboardService.getFleetNtvPortalConsumption(projectId, TimeZoneFactory.getTzFromCookie(), function (data) {
            callback(data);
        });
    };

    factory.getProjectSynchronizationState = function (projectId, callback) {
        DashboardService.getFleetNtvPortalContent(projectId, function (data) {
            dashboardUtil.parseSynchronizationState(data, function (data) {
                callback(data);
            })
        });
    };

    /**
     * This function will first fetch the needed data (logins, avgConsumed, vung and sqi's).
     * It then will process these datasets (transform the data for highcharts) and add the axes in the objects
     * @param projectId     the project id
     * @param trainId       the train id
     * @returns {*} promise that contains a Map object
     */
    factory.fetchTrainData = function (projectId) {
        var deferredArray = [];
        var timezone = TimeZoneFactory.getTzFromCookie();
        deferredArray.push(DashboardService.getFleetTotalLogins(projectId, timezone).$promise);
        deferredArray.push(DashboardService.getFleetConsumptionAverages(projectId, timezone).$promise);
        deferredArray.push(DashboardService.getFleetVuNgAverages(projectId, timezone).$promise);
        deferredArray.push(DashboardService.getFleetSqiAverages(projectId, timezone).$promise);

        var promise = $q.all(deferredArray).then(function (data) {
            var map = new Map();
            map.set("logins", TimeZoneFactory.addTimeZoneToTimestamp(data[0]));
            map.set("avgConsumed", TimeZoneFactory.addTimeZoneToTimestamp(data[1]));
            map.set("vung", TimeZoneFactory.addTimeZoneToTimestamp(data[2]));
            map.set("sla", TimeZoneFactory.addTimeZoneToTimestamp(data[3]));
            return map;
        });
        return promise;
    };

    factory.getProjectSqiGauges = function (projectId, sqiToDivLinker) {
        var period = nocUtil.beginAndEndOfDate(new Date());
        var utcPeriod = TimeZoneFactory.formatPeriodInCurrentTimezone(period.from, period.to);

        TripService.getFleetSqis({
            'projectId': projectId,
            'from': utcPeriod.start,
            'to': utcPeriod.end
        }, function (data) {
            data.forEach(function (sqi) {
                dashboardUtil.createSqiGauge(sqi, sqiToDivLinker);
            })

        });
    };

    return factory;
}];
